import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logo-vrjmof2022.svg'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "header-wrap" }
const _hoisted_3 = { class: "header-inner" }
const _hoisted_4 = { class: "header-logo" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "VR JMoF"
}, null, -1)
const _hoisted_6 = { class: "header-menu" }
const _hoisted_7 = { class: "mobile-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_TheLanguageSwitch = _resolveComponent("TheLanguageSwitch")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h1", _hoisted_4, [
            _createVNode(_component_router_link, {
              tag: "a",
              to: "/"
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                tag: "a",
                to: "/access"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].access), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                tag: "a",
                to: "/program"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].program), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                tag: "a",
                to: "/access/instances"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].instances), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                tag: "a",
                to: "/program/schedule"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].schedule), 1)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, {
                tag: "a",
                to: "/faq_contact"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].faqContact), 1)
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_TheLanguageSwitch)
        ])
      ])
    ]),
    _createElementVNode("ul", _hoisted_7, [
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          tag: "a",
          to: "/access"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].access), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          tag: "a",
          to: "/program"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].program), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          tag: "a",
          to: "/program/schedule"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].schedule), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", null, [
        _createVNode(_component_router_link, {
          tag: "a",
          to: "/faq_contact"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.headerNav[_ctx.locale].faqContact), 1)
          ]),
          _: 1
        })
      ])
    ])
  ], 64))
}